// extracted by mini-css-extract-plugin
export default {"table":"styles_table__ZGl0v","smallFont":"styles_smallFont__b913q"};